import { MapBuilder, px, type Decor, type MapDef } from '../mapdef';

/** A gallery of the Palace Museum: treasures in glass cases on polished marble. */
const b = new MapBuilder(28, 16, ' ');
b.room(0, 0, 28, 16, 'u');
b.fill(13, 15, 2, 1, 'D');

const at = (tx: number, ty: number) => ({ x: px(tx), y: px(ty) });

const decor: Decor[] = [
  { kind: 'hangingScroll', x: px(2), y: 2, wall: true, variant: 0 },
  { kind: 'hangingScroll', x: px(8), y: 2, wall: true, variant: 1 },
  { kind: 'hangingScroll', x: px(19), y: 2, wall: true, variant: 2 },
  { kind: 'hangingScroll', x: px(25), y: 2, wall: true, variant: 0 },
  { kind: 'museumBanner', x: px(12), y: 1, w: px(4), wall: true },
  ...[4, 10, 17, 23].map((tx) => ({ kind: 'stanchion' as const, ...at(tx + 1, 8), w: px(3) })),
  { kind: 'pillar', ...at(1, 14), solid: { x: px(1) - 6, y: px(14) - 6, w: 12, h: 6 } },
  { kind: 'pillar', ...at(26, 14), solid: { x: px(26) - 6, y: px(14) - 6, w: 12, h: 6 } },
  { kind: 'museumBench', ...at(14, 8), w: px(4), solid: { x: px(12), y: px(8) - 6, w: px(4), h: 6 } },
  { kind: 'pottedPlant', x: px(1) + 8, y: px(2) + 12, solid: { x: px(1) + 2, y: px(2) + 6, w: 12, h: 6 } },
  { kind: 'pottedPlant', x: px(26) + 8, y: px(2) + 12, solid: { x: px(26) + 2, y: px(2) + 6, w: 12, h: 6 } },
];

export const museum: MapDef = {
  id: 'museum',
  w: b.w,
  h: b.h,
  rows: b.rows(),
  indoor: true,
  theme: { wallFace: '#7a2a22', wallLight: '#9a3a2e', wainscot: '#3a2418', wallTop: '#1e1410' },
  // No door: you leave by MRT (the `muExit` object at the entrance).
  doors: [],
  decor,
  areas: [{ key: 'museum', rect: { x: 0, y: 0, w: px(28), h: px(16) } }],
  lights: [
    ...[5, 11, 18, 24].map((tx) => ({ x: px(tx) + 8, y: px(4), r: 60, color: '255,230,180' })),
    { x: px(9), y: px(10), r: 70, color: '255,230,180' },
    { x: px(20), y: px(10), r: 60, color: '255,230,180' },
  ],
};
